import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import { ReduceStore } from 'flux/utils';
import { Map } from 'immutable';

const makeKey = ({courseId, userId}) => (`[${courseId}|${userId}]`);

class CourseModuleSubscriptionStoreStore extends ReduceStore {


    getInitialState() {
        return Map();
    }

    get(courseId, userId) {
        return this.getState().get(makeKey({courseId, userId}));
    }

    has(courseId, userId) {
        return this.getState().has(makeKey({courseId, userId}));
    }

    reduce(state, action) {
        let key;
        switch (action.type) {
            case ActionTypes.COURSE_MODULE_SUBSCRIPTION_LIST_SUCCESS:
                return this.getState().set(makeKey(action.payload), action.data);

            default:
                return state;
        }
    }
}

export default new CourseModuleSubscriptionStoreStore(CentricDispatcher);

